module.exports = __webpack_public_path__ + "img/our-gurantees.bca216e2.svg";